import {useEffect, useMemo} from 'react'
import {useParams} from 'react-router'
import styles from './DialogModeration.module.scss'
import {cx} from '../../../../utils'
import {ReactComponent as Dialog} from '../../../../assets/Icons/Dialog.svg'
import {ReactComponent as Like} from '../../../../assets/Icons/Like2.svg'
import {ReactComponent as Dislike} from '../../../../assets/Icons/Dislike.svg'
import {ResponsesList} from '../ResponsesList/ResponsesList'
import {
  disconnectConversationSocket,
  initiateConversationSocketConnection,
} from '../../../../api/Sockets/conversation.socket.service'
import {DialogViolations} from '../DialogViolations/DialogViolations'
import {dialogApi} from '../../../../api/dialogApi'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../Translation/English/dialog'

interface IDialogModerationProps {
  showViolations: boolean
  setShowViolations: (value: boolean) => void
}

export const DialogModeration: React.FC<IDialogModerationProps> = ({
  showViolations,
  setShowViolations,
}) => {
  const wt = useWt()
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '')

  const statClassName = useMemo(
    () =>
      dialogDetails?.responses?.length
        ? styles.dialogModerationStatNotEmpty
        : styles.dialogModerationStatEmpty,
    [dialogDetails?.responses],
  )

  const handleBeforeUnload = (): void => disconnectConversationSocket()
  useEffect(() => {
    initiateConversationSocketConnection(dialogId)
    window.addEventListener('beforeunload', handleBeforeUnload)
    return (): void => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      disconnectConversationSocket()
    }
  }, [dialogId])

  return (
    <div className={styles.dialogModeration}>
      {showViolations && (
        <DialogViolations
          showViolations={showViolations}
          setShowViolations={setShowViolations}
        />
      )}
      <div className={styles.dialogModerationDetails}>
        <div className={styles.dialogModerationQuestion}>
          {dialogDetails?.questionText}
        </div>
        <div className={styles.dialogModerationStats}>
          <div className={cx(styles.dialogModerationStatItem, statClassName)}>
            <Dialog />
            <div>{dialogDetails?.responses?.length}</div>
            <div>{wt(DIALOG.responses)}</div>
          </div>
          {dialogDetails?.enableLikes && (
            <div className={cx(styles.dialogModerationStatItem, statClassName)}>
              <Like /> <div>{dialogDetails.likesCount}</div>
              <div>{wt(DIALOG.likes)}</div>
            </div>
          )}
          {dialogDetails?.enableDislikes && (
            <div className={cx(styles.dialogModerationStatItem, statClassName)}>
              <Dislike /> <div>{dialogDetails.dislikesCount}</div>
              <div>{wt(DIALOG.dislikes)}</div>
            </div>
          )}
        </div>
      </div>
      {dialogDetails && (dialogDetails.responses?.length ?? 0) > 0 && (
        <ResponsesList
          responses={dialogDetails.responses ?? []}
          dialogDetails={dialogDetails}
          isUserModerator={true}
        />
      )}
      {dialogDetails?.responses?.length === 0 && (
        <div className={styles.dialogModerationEmptyResponses}>
          {wt(DIALOG.noResponsesText)}
        </div>
      )}
    </div>
  )
}
